export function TicketCardSkeleton() {
  return (
    <div className="animate-pulse space-y-3 rounded-lg border border-slate-200 bg-white p-4">
      <div className="flex justify-between">
        <div className="h-4 w-24 rounded bg-slate-200" />
        <div className="h-6 w-20 rounded bg-slate-200" />
      </div>
      <div className="h-4 w-48 rounded bg-slate-200" />
      <div className="h-3 w-36 rounded bg-slate-200" />
    </div>
  );
}

export function TableRowSkeleton({ columns = 5 }: { columns?: number }) {
  return (
    <tr className="animate-pulse">
      {Array.from({ length: columns }).map((_, i) => (
        <td key={i} className="px-4 py-3">
          <div className="h-4 w-full rounded bg-slate-200" />
        </td>
      ))}
    </tr>
  );
}

export function PageLoadingSkeleton() {
  return (
    <div className="animate-pulse space-y-4 p-6">
      <div className="h-8 w-48 rounded bg-slate-200" />
      <div className="grid grid-cols-2 gap-4 md:grid-cols-4">
        {[1, 2, 3, 4].map((i) => (
          <div key={i} className="h-24 rounded bg-slate-200" />
        ))}
      </div>
      <div className="space-y-3">
        {[1, 2, 3, 4, 5].map((i) => (
          <div key={i} className="h-16 rounded bg-slate-200" />
        ))}
      </div>
    </div>
  );
}
